import React, {Fragment} from 'react'
import {inject, observer} from 'mobx-react'
import {PartyStore} from '../../stores/PartyStore'
import {ICandidate} from '../../types/candidate'
import {ConstituencyStore} from '../../stores/ConstituencyStore'
import './CandidateData.scss'

interface CandidateDataProps {
  constituencyStore?: ConstituencyStore
  partyStore?: PartyStore
  candidate: ICandidate
  handleOnChange: (val: any, key: string) => void
}

const CandidateData: React.FC<CandidateDataProps> = inject(
  'partyStore',
  'constituencyStore'
)(
  observer(({partyStore, candidate, handleOnChange}) => {
    if (!candidate || !partyStore) return null

    const getPartyName = (key: string) => {
      const electionData = candidate.election_data?.[key]
      let partyId: number | undefined

      if (electionData.party_id) {
        partyId = electionData.party_id
      } else if (candidate.party_id) {
        partyId = candidate.party_id
      }

      return partyStore.parties.find(p => p.id === partyId)?.name || ''
    }

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      handleOnChange(event.target.value, 'first_name')
    }

    return (
      <div className="candidate-data">
        {Object.keys(candidate.election_data || {}).map(key => {
          if (!Object.keys(candidate.election_data[key]).length) return null
          const label = key === 'municipality' ? 'Puolue kuntavaaleissa:' : 'Puolue aluevaaleissa:'
          const partyName = getPartyName(key)
          return (
            <Fragment key={`candidate-data-${key}`}>
              <div className="candidate-data__label">{label}</div>
              <div className="candidate-data__data">{partyName}</div>
            </Fragment>
          )
        })}

        <div className="candidate-data__label">Nimi: </div>
        <div className="candidate-data__data">{`${candidate.given_name || ''} ${candidate.last_name || ''}`}</div>
        <div className="candidate-data__label nickname">* Kutsumanimi:</div>
        <div className="candidate-data__data with-info-text">
          <input onChange={handleNameChange} value={candidate.first_name || ''} className="candidate-data__data-input" type="text" />
          <div className="candidate-data__info-text">Kirjoita samassa muodossa kuin ehdokasasettelussa</div>
        </div>
        <div className="candidate-data__label">Vaalikoneessa näkyvä nimi:</div>
        <div className="candidate-data__data">{`${candidate.first_name || ''} ${candidate.last_name || ''}`}</div>
      </div>
    )
  })
)

export default CandidateData
